/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface AdvertisingCampaignStrategyRowData
 */
export interface AdvertisingCampaignStrategyRowData {
    /**
     * 
     * @type {string}
     * @memberof AdvertisingCampaignStrategyRowData
     */
    campaignId?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvertisingCampaignStrategyRowData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvertisingCampaignStrategyRowData
     */
    platform?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvertisingCampaignStrategyRowData
     */
    composition?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdvertisingCampaignStrategyRowData
     */
    categories?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdvertisingCampaignStrategyRowData
     */
    domains?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingCampaignStrategyRowData
     */
    adCount?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdvertisingCampaignStrategyRowData
     */
    spend?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingCampaignStrategyRowData
     */
    spendShare?: number;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingCampaignStrategyRowData
     */
    clicks?: number;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingCampaignStrategyRowData
     */
    impressions?: number;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingCampaignStrategyRowData
     */
    ctr?: number | null;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdvertisingCampaignStrategyRowData
     */
    cpc?: MoneyOutput | null;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdvertisingCampaignStrategyRowData
     */
    cpm?: MoneyOutput | null;
}

/**
 * Check if a given object implements the AdvertisingCampaignStrategyRowData interface.
 */
export function instanceOfAdvertisingCampaignStrategyRowData(value: object): value is AdvertisingCampaignStrategyRowData {
    return true;
}

export function AdvertisingCampaignStrategyRowDataFromJSON(json: any): AdvertisingCampaignStrategyRowData {
    return AdvertisingCampaignStrategyRowDataFromJSONTyped(json, false);
}

export function AdvertisingCampaignStrategyRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdvertisingCampaignStrategyRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'campaignId': json['campaignId'] == null ? undefined : json['campaignId'],
        'name': json['name'] == null ? undefined : json['name'],
        'platform': json['platform'] == null ? undefined : json['platform'],
        'composition': json['composition'] == null ? undefined : json['composition'],
        'categories': json['categories'] == null ? undefined : json['categories'],
        'domains': json['domains'] == null ? undefined : json['domains'],
        'adCount': json['adCount'] == null ? undefined : json['adCount'],
        'spend': json['spend'] == null ? undefined : MoneyOutputFromJSON(json['spend']),
        'spendShare': json['spendShare'] == null ? undefined : json['spendShare'],
        'clicks': json['clicks'] == null ? undefined : json['clicks'],
        'impressions': json['impressions'] == null ? undefined : json['impressions'],
        'ctr': json['ctr'] === undefined ? undefined : json['ctr'] === null ? null : json['ctr'],
        'cpc': json['cpc'] === undefined ? undefined : json['cpc'] === null ? null : MoneyOutputFromJSON(json['cpc']),
        'cpm': json['cpm'] === undefined ? undefined : json['cpm'] === null ? null : MoneyOutputFromJSON(json['cpm']),
    };
}

export function AdvertisingCampaignStrategyRowDataToJSON(json: any): AdvertisingCampaignStrategyRowData {
    return AdvertisingCampaignStrategyRowDataToJSONTyped(json, false);
}

export function AdvertisingCampaignStrategyRowDataToJSONTyped(value?: AdvertisingCampaignStrategyRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'campaignId': value['campaignId'],
        'name': value['name'],
        'platform': value['platform'],
        'composition': value['composition'],
        'categories': value['categories'],
        'domains': value['domains'],
        'adCount': value['adCount'],
        'spend': MoneyOutputToJSON(value['spend']),
        'spendShare': value['spendShare'],
        'clicks': value['clicks'],
        'impressions': value['impressions'],
        'ctr': value['ctr'],
        'cpc': MoneyOutputToJSON(value['cpc']),
        'cpm': MoneyOutputToJSON(value['cpm']),
    };
}

